import React, { useState } from 'react';
import AvatarMenu from 'components/AvatarMenu';
import EventCreateCard from 'components/EventCreateCard';

import logo from '../../assets/thalo_logo.png';
import wiggle from '../../assets/wiggle_inverse.svg';

import './FirstEventWalkthrough.scss';

const FirstEventWalkthrough = () => {
	const [creating, setCreating] = useState(false);
	const handleCreateEvent = () => {
		console.log('Creating Event...');
		setCreating(true);
	};
	const creatingClass = creating ? 'creating-event' : '';
	return (
		<div className={`FirstEventWalkthrough ${creatingClass}`}>
			<div className="left">
				<img src={logo} className="logo" alt="thalo logo" />
				<div className="page-title">
					Create Your&nbsp;
					<br />
					First Event
				</div>
			</div>
			<div className="right">
				<EventCreateCard onCreate={handleCreateEvent} />
			</div>
			<AvatarMenu />
			<img className="wiggle-inverse" src={wiggle} alt="wiggle-inverse" />
			<div className="background" />
			<div className="overlay" />
		</div>
	);
};

export const FirstEventWalkthroughSkeleton = () => {
	return (
		<div className="FirstEventWalkthrough">
			<div className="left">
				<div className="page-title">
					Create Your&nbsp;
					<br />
					First Event
				</div>
			</div>
			<img className="wiggle-inverse" src={wiggle} alt="wiggle-inverse" />
			<div className="background" />
			<div className="overlay" />
		</div>
	);
};

export default FirstEventWalkthrough;
